import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { turnosService, diasBloqueadosService, serviciosService } from "../../services/api";
import { enviarEmailConfirmacion } from "../../config/EmailService";
import { CATEGORIAS_RESERVA, agruparServiciosPorNombre, nombreCompletoServicio, etiquetaVariante } from "../../config/servicios";
import CheckAnimado from "../Animaciones/CheckAnimado";
import "./ModalReserva.css";

function ModalReserva({ abierto, onCerrar }) {
  const [paso, setPaso] = useState(1);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("");
  const [nombreServicioSeleccionado, setNombreServicioSeleccionado] = useState("");
  const [varianteSeleccionada, setVarianteSeleccionada] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [horaSeleccionada, setHoraSeleccionada] = useState("");
  const [horasDisponibles, setHorasDisponibles] = useState([]);
  const [notas, setNotas] = useState("");
  const [cargando, setCargando] = useState(false);
  const [exito, setExito] = useState(false);
  const [errorFecha, setErrorFecha] = useState("");
  const [diasBloqueados, setDiasBloqueados] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const navigate = useNavigate();

  const _nombre = localStorage.getItem("nombre");
  const _token = localStorage.getItem("token");

  const _grupoServicios = agruparServiciosPorNombre(catalogo, categoriaSeleccionada);
  const _grupoSeleccionado = _grupoServicios.find((g) => g.nombre === nombreServicioSeleccionado);
  const _variantesDelNombre = _grupoSeleccionado ? _grupoSeleccionado.variantes : [];
  const _necesitaVariante = _variantesDelNombre.length > 1;
  const _pasos = _necesitaVariante
    ? ["categoria", "servicio", "variante", "fecha", "confirmacion"]
    : ["categoria", "servicio", "fecha", "confirmacion"];
  const _pasoActual = _pasos[paso - 1];

  useEffect(() => {
    if (abierto) {
      document.body.style.overflow = "hidden";
      setPaso(1);
      setCategoriaSeleccionada("");
      setNombreServicioSeleccionado("");
      setVarianteSeleccionada(null);
      setFechaSeleccionada("");
      setHoraSeleccionada("");
      setNotas("");
      setExito(false);
      setErrorFecha("");
      diasBloqueadosService.obtenerTodos()
        .then((respuesta) => setDiasBloqueados(respuesta.data))
        .catch(() => setDiasBloqueados([]));
      serviciosService.obtenerTodos()
        .then((respuesta) => setCatalogo(respuesta.data))
        .catch(() => setCatalogo([]));
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [abierto]);

  const elegirCategoria = (categoriaId) => {
    setCategoriaSeleccionada(categoriaId);
    setNombreServicioSeleccionado("");
    setVarianteSeleccionada(null);
    setPaso(2);
  };

  const elegirServicio = (nombre) => {
    setNombreServicioSeleccionado(nombre);
    const _grupo = _grupoServicios.find((g) => g.nombre === nombre);
    const _variantes = _grupo ? _grupo.variantes : [];
    setVarianteSeleccionada(_variantes.length === 1 ? _variantes[0] : null);
  };

  const _esSabado = fechaSeleccionada ? new Date(fechaSeleccionada + "T00:00:00").getDay() === 6 : false;
  const _horasConAnticipacion = fechaSeleccionada
    ? horasDisponibles.filter(
        (hora) => new Date(`${fechaSeleccionada}T${hora}:00`).getTime() - Date.now() >= 24 * 60 * 60 * 1000
      )
    : [];
  const _hayHorasMuyCercanas = !_esSabado && horasDisponibles.length > 0 && _horasConAnticipacion.length < horasDisponibles.length;
  const _requiereCoordinarPorWhatsapp =
    fechaSeleccionada && (_esSabado || (horasDisponibles.length > 0 && _horasConAnticipacion.length === 0));

  useEffect(() => {
    if (fechaSeleccionada && varianteSeleccionada && !_esSabado) {
      obtenerHorasDisponibles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fechaSeleccionada, varianteSeleccionada]);

  const obtenerHorasDisponibles = async () => {
    try {
      const respuesta = await turnosService.obtenerDisponibles(fechaSeleccionada, nombreCompletoServicio(varianteSeleccionada));
      setHorasDisponibles(respuesta.data);
    } catch (error) {
      console.error("Error al obtener horas", error);
    }
  };

  const manejarCambioFecha = (e) => {
    const _valor = e.target.value;
    const _fechaElegida = new Date(_valor + "T00:00:00");
    const _diaSemana = _fechaElegida.getDay();

    if (_diaSemana === 0) {
      setErrorFecha("Los domingos el estudio esta cerrado.");
      setFechaSeleccionada("");
      setHoraSeleccionada("");
      return;
    }

    const _estaBloqueado = diasBloqueados.some((d) => d.fecha.slice(0, 10) === _valor);
    if (_estaBloqueado) {
      setErrorFecha("Ese día el estudio está cerrado. Elegí otra fecha.");
      setFechaSeleccionada("");
      setHoraSeleccionada("");
      return;
    }

    setErrorFecha("");
    setFechaSeleccionada(_valor);
    setHoraSeleccionada("");
  };

  const obtenerFechaMinima = () => {
    return new Date().toISOString().split("T")[0];
  };

  const formatearFechaLegible = (fecha) => {
    const _fecha = new Date(fecha + "T00:00:00");
    return _fecha.toLocaleDateString("es-UY", { weekday: "long", day: "2-digit", month: "2-digit" });
  };

  const abrirWhatsAppTurnoEspecial = () => {
    const _servicio = varianteSeleccionada ? nombreCompletoServicio(varianteSeleccionada) : nombreServicioSeleccionado;
    const _mensaje = `Hola Cata! Soy ${_nombre || "una clienta"}. Quiero coordinar un turno de ${_servicio} para el ${formatearFechaLegible(fechaSeleccionada)}, fuera del horario habitual. ¿Me contás cómo seguimos?`;
    const _url = `https://wa.me/598099481951?text=${encodeURIComponent(_mensaje)}`;
    window.open(_url, "_blank");
  };

  const confirmarReserva = async () => {
    setCargando(true);
    try {
      const _nombreServicio = nombreCompletoServicio(varianteSeleccionada);
      const _fechaHora = new Date(`${fechaSeleccionada}T${horaSeleccionada}:00`);

      await turnosService.crearTurno({
        servicio: _nombreServicio,
        fechaHora: _fechaHora.toISOString(),
        notas: notas,
        precio: varianteSeleccionada.precio,
        duracionMinutos: 60,
      });

      const _email = localStorage.getItem("email");
      await enviarEmailConfirmacion({
        nombre: _nombre,
        email: _email,
        servicio: _nombreServicio,
        fecha: fechaSeleccionada,
        hora: horaSeleccionada,
        precio: varianteSeleccionada.precio,
      });

      setExito(true);
    } catch (error) {
      alert("Error al crear el turno. Intenta de nuevo.");
    } finally {
      setCargando(false);
    }
  };

  if (!_token) {
    return (
      abierto && (
          <motion.div
            className="modal-fondo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            onClick={onCerrar}
          >
            <motion.div
              className="modal-contenido"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-cerrar" onClick={onCerrar}>✕</button>
              <div className="modal-no-logueado">
                <span className="modal-icono-grande">✦</span>
                <h2>Para reservar necesitas iniciar sesión</h2>
                <p>Creá tu cuenta gratis o ingresá para reservar tu turno.</p>
                <div className="modal-no-logueado-botones">
                  <button className="btn-principal" onClick={() => { onCerrar(); navigate("/login"); }}>
                    Iniciar sesión
                  </button>
                  <button className="btn-secundario" onClick={onCerrar}>
                    Cancelar
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )
    );
  }

  return (
      abierto && (
        <motion.div
          className="modal-fondo"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          onClick={onCerrar}
        >
          <motion.div
            className="modal-contenido"
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="modal-cerrar" onClick={onCerrar}>✕</button>

            {exito ? (
              <div className="modal-exito">
                <CheckAnimado />
                <h2>Turno reservado!</h2>
                <p>Te esperamos el {fechaSeleccionada} a las {horaSeleccionada}.</p>
                <p className="modal-exito-sub">Recibirás una confirmación pronto.</p>
                <div className="modal-no-logueado-botones">
                  <button className="btn-principal" onClick={() => { onCerrar(); navigate("/mis-turnos"); }}>
                    Ver mis turnos
                  </button>
                  <button className="btn-secundario" onClick={onCerrar}>
                    Cerrar
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="modal-header">
                  <div className="modal-progreso">
                    {_pasos.map((_clave, _indice) => (
                      <div key={_clave} className={"modal-paso " + (paso >= _indice + 1 ? "activo" : "")}>
                        <span className="modal-paso-numero">{_indice + 1}</span>
                      </div>
                    ))}
                  </div>
                  <h2 className="modal-titulo">
                    {_pasoActual === "categoria" && "¿Qué tipo de servicio?"}
                    {_pasoActual === "servicio" && "Elegí tu servicio"}
                    {_pasoActual === "variante" && "Elegí el detalle"}
                    {_pasoActual === "fecha" && "Elegí fecha y hora"}
                    {_pasoActual === "confirmacion" && "Confirmá tu turno"}
                  </h2>
                  <p className="modal-bienvenida">Hola {_nombre} 🌸</p>
                </div>

                <div className="modal-cuerpo">
                  {_pasoActual === "categoria" && (
                    <div className="modal-categorias-grid">
                      {CATEGORIAS_RESERVA.map((categoria) => (
                        <div
                          key={categoria.id}
                          className={"modal-categoria-card " + (categoriaSeleccionada === categoria.id ? "seleccionado" : "")}
                          onClick={() => elegirCategoria(categoria.id)}
                        >
                          <p className="modal-categoria-nombre">{categoria.nombre}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {_pasoActual === "servicio" && (
                    <div className="modal-servicios-grid">
                      {_grupoServicios.length === 0 ? (
                        <p className="sin-horas">No hay servicios cargados en esta categoría todavía.</p>
                      ) : (
                        _grupoServicios.map((grupo) => (
                          <div
                            key={grupo.nombre}
                            className={"modal-servicio-card " + (nombreServicioSeleccionado === grupo.nombre ? "seleccionado" : "")}
                            onClick={() => elegirServicio(grupo.nombre)}
                          >
                            <p className="modal-servicio-nombre">{grupo.nombre}</p>
                            <div className="modal-servicio-info">
                              <span>{grupo.variantes.length > 1 ? "Varias opciones" : ""}</span>
                              <span className="modal-servicio-precio">
                                {grupo.variantes.length > 1 ? "desde " : ""}${Math.min(...grupo.variantes.map((v) => v.precio))}
                              </span>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  )}

                  {_pasoActual === "variante" && (
                    <div className="modal-servicios-grid">
                      {_variantesDelNombre.map((variante) => (
                        <div
                          key={variante.id}
                          className={"modal-servicio-card " + (varianteSeleccionada?.id === variante.id ? "seleccionado" : "")}
                          onClick={() => setVarianteSeleccionada(variante)}
                        >
                          <p className="modal-servicio-nombre">{etiquetaVariante(variante, nombreServicioSeleccionado)}</p>
                          <div className="modal-servicio-info">
                            <span className="modal-servicio-precio">${variante.precio}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {_pasoActual === "fecha" && (
                    <div className="modal-fecha-contenido">
                      <div className="formulario-grupo">
                        <label className="formulario-label">Fecha</label>
                        <input
                          type="date"
                          className="formulario-input"
                          min={obtenerFechaMinima()}
                          value={fechaSeleccionada}
                          onChange={manejarCambioFecha}
                        />
                        <p className="fecha-aviso">Atendemos de lunes a viernes de 9:00 a 19:00 hs.</p>
                        {errorFecha && <p className="fecha-error">{errorFecha}</p>}
                      </div>

                      {fechaSeleccionada && (
                        _requiereCoordinarPorWhatsapp ? (
                          <div className="aviso-turno-especial">
                            <p>
                              {_esSabado
                                ? "Los sábados coordinamos los turnos por WhatsApp: contanos el servicio y el horario que buscás y te confirmamos disponibilidad (este horario especial tiene un costo adicional)."
                                : "Para turnos con menos de 24 horas de anticipación coordinamos por WhatsApp para confirmar que tengamos lugar (este horario especial tiene un costo adicional)."}
                            </p>
                            <button type="button" className="btn-principal" onClick={abrirWhatsAppTurnoEspecial}>
                              Coordinar por WhatsApp
                            </button>
                          </div>
                        ) : (
                          <div className="formulario-grupo">
                            <label className="formulario-label">Horario disponible</label>
                            {horasDisponibles.length === 0 ? (
                              <p className="sin-horas">No hay horarios disponibles para ese día</p>
                            ) : (
                              <div className="horas-grid">
                                {_horasConAnticipacion.map((hora) => (
                                  <button
                                    key={hora}
                                    className={"hora-btn " + (horaSeleccionada === hora ? "seleccionada" : "")}
                                    onClick={() => setHoraSeleccionada(hora)}
                                  >
                                    {hora}
                                  </button>
                                ))}
                              </div>
                            )}
                            {_hayHorasMuyCercanas && (
                              <p className="fecha-aviso">
                                ¿Necesitás un horario más cercano? Se puede coordinar por WhatsApp con un costo adicional
                                por reservar con menos de 24 horas de anticipación.{" "}
                                <button type="button" className="link-whatsapp" onClick={abrirWhatsAppTurnoEspecial}>
                                  Escribir por WhatsApp
                                </button>
                              </p>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  )}

                  {_pasoActual === "confirmacion" && (
                    <div className="modal-confirmacion">
                      <div className="resumen-turno">
                        <div className="resumen-item">
                          <span className="resumen-label">Servicio</span>
                          <span className="resumen-valor">{nombreCompletoServicio(varianteSeleccionada)}</span>
                        </div>
                        <div className="resumen-item">
                          <span className="resumen-label">Fecha</span>
                          <span className="resumen-valor">{fechaSeleccionada}</span>
                        </div>
                        <div className="resumen-item">
                          <span className="resumen-label">Hora</span>
                          <span className="resumen-valor">{horaSeleccionada}</span>
                        </div>
                        <div className="resumen-item">
                          <span className="resumen-label">Precio desde</span>
                          <span className="resumen-valor resumen-precio">${varianteSeleccionada?.precio}</span>
                        </div>
                      </div>

                      <p className="precio-nota">
                        * Precio orientativo: el valor final se confirma en el estudio según los agregados o detalles extra que sumes el día del turno.
                      </p>

                      <div className="politica-cancelacion">
                        Podes cancelar hasta 48 horas antes sin costo.
                      </div>

                      <div className="formulario-grupo">
                        <label className="formulario-label">Notas (opcional)</label>
                        <textarea
                          className="formulario-input formulario-textarea"
                          placeholder="Algun detalle especial..."
                          value={notas}
                          onChange={(e) => setNotas(e.target.value)}
                          rows={2}
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  {paso > 1 && (
                    <button className="btn-secundario" onClick={() => setPaso(paso - 1)}>
                      ← Atrás
                    </button>
                  )}
                  {_pasoActual !== "confirmacion" && (
                    <button
                      className="btn-principal"
                      disabled={
                        (_pasoActual === "servicio" && !nombreServicioSeleccionado) ||
                        (_pasoActual === "variante" && !varianteSeleccionada) ||
                        (_pasoActual === "fecha" && (!fechaSeleccionada || !horaSeleccionada))
                      }
                      onClick={() => setPaso(paso + 1)}
                    >
                      Siguiente →
                    </button>
                  )}
                  {_pasoActual === "confirmacion" && (
                    <button
                      className="btn-rosa"
                      disabled={cargando}
                      onClick={confirmarReserva}
                    >
                      {cargando ? "Reservando..." : "Confirmar turno ✦"}
                    </button>
                  )}
                </div>
              </>
            )}
          </motion.div>
        </motion.div>
      )
  );
}

export default ModalReserva;